
import React, { useState } from "react";
import { Typography, Input, Space, Button, Spin, DatePicker } from "antd";
import { EditFilled, CloseCircleFilled, CheckCircleFilled, SyncOutlined } from "@ant-design/icons"
import './styles.css'
import PropTypes from 'prop-types'
import moment from 'moment';
const EditableText =(props)=> {
    const [editing, setEditing] = useState(false)
    const [updatedValue, setValue] = useState(props.value)
    const {Text} = Typography
    const {TextArea} = Input
    return(
        !editing ?
        <Space>
            <Text type='secondary' key={props.textKey} style={{fontSize: props.fontSize,color: 'rgba(0,0,0,0.6)'}}>{props.value}</Text>
            {props.edit ? <Button key={props.editButtonKey} onClick={()=>setEditing(true)} className='button' icon={<EditFilled style={{color: 'gray'}}/>}></Button> : null}
            {props.updating ? <Spin indicator={<SyncOutlined style={{fontSize: 14}} spin/>}></Spin> : null}
        </Space> : 
        <Space>
            {props.type === "textArea" ?
                <TextArea style={{width: props.width ? props.width : '20vw'}} key={props.inputKey} defaultValue = {props.value} onChange={(e)=> setValue(e.target.value)}></TextArea> :
                props.type === "date" ?
                <DatePicker size="small" defaultValue={moment(props.value)} onChange={(date,dateString)=> setValue(dateString)}/> : 
                <Input key={props.inputKey} style={{width: props.width ? props.width : '20vw'}} defaultValue = {props.value} onChange={(e)=> setValue(e.target.value)}></Input>}
            <Button key={props.cancelButtonKey} className='button' onClick={()=>{
                setEditing(false)
            }} icon={<CloseCircleFilled style={{color: 'lightgray',fontSize: 25}} />}></Button>
            <Button key={props.saveButtonKey} className='button' onClick={()=>{
                setEditing(false)
                props.save(updatedValue,updatedValue !== props.value)
            }} icon={<CheckCircleFilled style={{color: '#1890ff',fontSize: 25}} />}></Button>
        </Space>
    )
}
EditableText.propTypes = {
    updating: PropTypes.any,
    edit: PropTypes.any,
    save: PropTypes.any,
    textKey: PropTypes.any,
    editButtonKey: PropTypes.any,
    inputKey: PropTypes.any,
    cancelButtonKey: PropTypes.any,
    saveButtonKey: PropTypes.any,
    value: PropTypes.any,
    fontSize: PropTypes.any,
    type: PropTypes.any
}
export default EditableText